<template>
  <div
    class="confetti-dropdown"
    :class="{ open: isOpen }"
    @click="toggleDropdown"
    @keyup.enter="toggleDropdown"
  >
    <ConfettiIcon class="dropdown-icon" :icon="icon" />
    <ul
      v-if="isOpen"
      class="confetti-dropdown-list"
      :class="{ 'no-padding': hasLink }"
    >
      <li v-for="option in options" :key="option">
        {{ option }}
      </li>
    </ul>
  </div>
</template>

<script>
import ConfettiIcon from "./ConfettiIcon";

export default {
  name: "ConfettiDropdown",
  components: { ConfettiIcon },
  props: {
    hasLink: {
      type: Boolean,
    },
    options: {
      type: Array,
      required: true,
    },
    icon: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      isOpen: false,
    };
  },
  methods: {
    onClick({ target }) {
      if (!this.$el.contains(target)) {
        document.removeEventListener("click", this.onClick);
        this.isOpen = false;
      }
    },
    toggleDropdown() {
      if (!this.isOpen) {
        document.addEventListener("click", this.onClick);
      }

      this.isOpen = !this.isOpen;
    },
  },
};
</script>

<style lang="scss" scoped>
.dropdown-icon {
  align-items: center;
  block-size: 3rem;
  display: flex;
  font-size: 3rem;
  inline-size: 3rem;
  justify-content: center;
}

.no-padding > li {
  padding: 0;

  a {
    inline-size: 100%;
    padding-block: 1.4rem;
    padding-inline: 1.6rem;

    &:hover {
      text-decoration: none;
    }
  }
}
</style>
